export default __webpack_public_path__ + "static/media/info.8377824d.svg";